import {PLAYER_EVENT} from "../../../constants/PlayerConstants";
import {EventPlayerStoredObjects} from "../../../@types/response";
import {GeneralAction} from "../../../@types/actions";

export const PlayerEventAction = (data: EventPlayerStoredObjects): GeneralAction<EventPlayerStoredObjects> => ({
    type: PLAYER_EVENT,
    payload: data
});
